abs["datatables"] = {
    dataTablesInstances : [],
    getConfig           : function (oArgs)
    {
        return {
            "order"      : [
                [
                    2,
                    "asc"
                ]
            ],
            "lengthMenu" : [
                [
                    -1,
                    10,
                    25,
                    50,
                    100,
                    250,
                    500,
                    1000
                ],
                [
                    oArgs.all,
                    10,
                    25,
                    50,
                    100,
                    250,
                    500,
                    1000
                ]
            ],
            "oLanguage"  : abs.datatables.aoLanguage[oArgs.locale]
        };
    },
    helpers             : {
        fnNumberFormatter : function (sData, nPositions, bForce)
        {
            if ( isNaN(sData) )
            {
                return 0;
            }

            sData = parseFloat(sData);

            if ( bForce )
            {
                return $.fn.dataTable.render.number(abs.number.thousand, abs.number.decimal, nPositions, '').display(sData);
            }

            if ( sData % 1 !== 0 )
            {
                return $.fn.dataTable.render.number(abs.number.thousand, abs.number.decimal, nPositions, '').display(sData);
            }
            return $.fn.dataTable.render.number(abs.number.thousand, abs.number.decimal, 0, '').display(sData);
        }
    },

    fnCreateInputFilter : function ($tableContainer)
    {
        //Create the inputs under the Head
        $tableContainer.find('thead').append($("<tr class='head_filters' style='display: none;'>"));
        $tableContainer.find('th').each(function (i, e)
                                        {

                                            var title = $(this).text();
                                            $element  = $(this).parent().parent().find("tr:last");
                                            $element.append('<th><input class="header-search" type="text" placeholder="" style="width: 70px" /></th>'
                                            );
                                        }

        );

        /**
         * create the event
         */
        var aElementsToRemove = [];
        abs.datatables.dataTablesInstances[0].columns().every(function ()
                                                              {

                                                                  var dataSrc = this.column(this[0][0]).dataSrc();
                                                                  if ( dataSrc != null && typeof dataSrc.hasFilter != "undefined" &&
                                                                      dataSrc.hasFilter == true )
                                                                  {

                                                                      var that = this;
                                                                      fnSearch = function () {
                                                                          if ( that2.search() !== this2.value )
                                                                          {
                                                                              that2
                                                                              .search(this2.value)
                                                                              .draw();
                                                                              $(this2).focus();
                                                                          }

                                                                      };
                                                                      $element.find("input:eq(" + this[0][0] + ")").on('keyup change', function ()
                                                                                                                       {
                                                                                                                           clearTimeout($.data(this, 'timer'));
                                                                                                                           var wait = setTimeout(fnSearch, 700);
                                                                                                                           that2 = that;
                                                                                                                           this2 = this;
                                                                                                                           $(this).data('timer', wait);


                                                                                                                       }
                                                                      );
                                                                  }
                                                                  else
                                                                  {
                                                                      aElementsToRemove.push(this[0][0]);
                                                                  }
                                                              }
        );

        /**
         * Remove unecessary inputs
         */
        for ( var i = aElementsToRemove.length; i >= 0; i-- )
        {
            $element.find("input:eq(" + aElementsToRemove[i] + ")").off().remove();
        }

        $("#filters_toggle").find("span:last").on("click", function ()
                                                  {
                                                      $(".head_filters").toggle("fast", function ()
                                                                                {
                                                                                }
                                                      );
                                                  }
        );
    },

    fnInit     : function ($selector, oConfig)
    {
        if ($.fn.DataTable.isDataTable("#" + $selector.attr("id")))
        {
            $selector.dataTable().api().destroy();
            $selector.empty();
        }
        $selector.attr({"width" : "100%"});
        $selector.off();
        $selector.hide();

        $selector.on( 'preInit.dt', function ()
        {
            $(".ajax_load").show();
            $(this).hide();
        } );

        $selector.on( 'draw.dt', function ()
        {

            $(".ajax_load").hide();
            $(this).show();
        } );

        abs.datatables.dataTablesInstances.push($selector.DataTable(oConfig));

        //Add Input Filters on Datatables
        if (typeof abs.page.hasInputFilters != "undefined" && abs.page.hasInputFilters == true)
        {
            abs.datatables.fnCreateInputFilter($selector);
        }
    },
    aoLanguage : {
        get es_ES ()
        {
            return {
                "sProcessing"     : "Por favor espere mientras se cargan los datos ...",
                "sLengthMenu"     : "Mostrar _MENU_ registros",
                "sZeroRecords"    : "No se encontraron resultados",
                "sEmptyTable"     : "Ningún dato disponible en esta tabla",
                "sInfo"           : "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                "sInfoEmpty"      : "Mostrando registros del 0 al 0 de un total de 0 registros",
                "sInfoFiltered"   : "(filtrado de un total de _MAX_ registros)",
                "sInfoPostFix"    : "",
                "sSearch"         : "Búsqueda",
                "sUrl"            : "",
                "sInfoThousands"  : ",",
                "sLoadingRecords" : "Cargando...",
                "oPaginate"       : {
                    "sFirst"    : "Primero",
                    "sPrevious" : "Anterior",
                    "sNext"     : "Seguinte",
                    "sLast"     : "Último"
                },
                "oAria"           : {
                    "sSortAscending"  : ": Activar para ordenar la columna de manera ascendente",
                    "sSortDescending" : ": Activar para ordenar la columna de manera descendente"
                },
                language          : {
                    decimal : ",",
                }
            };
        },
        get en ()
        {
            return {
                "sProcessing"   : "Wait while data is being loaded ...",
                "sLengthMenu"   : "_MENU_ by page",
                "sZeroRecords"  : "No record found for that criteria",
                "sInfoEmpty"    : "showing 0 to 0 of 0 rows",
                "sInfo"         : "Showing from _START_ to _END_ of _TOTAL_ rows",
                "sInfoFiltered" : "",
                "sSearch"       : "Search",
                "oPaginate"     : {
                    "sFirst"    : "First",
                    "sPrevious" : "Previous",
                    "sNext"     : "Next",
                    "sLast"     : "Last"
                },
                language        : {
                    decimal : ".",
                }
            };
        },

        get en_GB ()
        {
            return {
                "sProcessing"   : "Wait while data is being loaded ...",
                "sLengthMenu"   : "_MENU_ by page",
                "sZeroRecords"  : "No record found for that criteria",
                "sInfoEmpty"    : "showing 0 to 0 of 0 rows",
                "sInfo"         : "Showing from _START_ to _END_ of _TOTAL_ rows",
                "sInfoFiltered" : "",
                "sSearch"       : "Search",
                "oPaginate"     : {
                    "sFirst"    : "First",
                    "sPrevious" : "Previous",
                    "sNext"     : "Next",
                    "sLast"     : "Last"
                },
                language        : {
                    decimal : ".",
                }
            };
        },

        get pt_BR ()
        {
            return {
                "sProcessing"   : "Aguarde enquanto os dados são carregados ...",
                "sLengthMenu"   : "_MENU_ por página",
                "sZeroRecords"  : "Nenhum registro correspondente ao critério encontrado",
                "sInfoEmpty"    : "Exibindo 0 a 0 de 0 registros",
                "sInfo"         : "Exibindo de _START_ a _END_ de _TOTAL_ registros",
                "sInfoFiltered" : "",
                "sSearch"       : "Procurar",
                "oPaginate"     : {
                    "sFirst"    : "Primeiro",
                    "sPrevious" : "Anterior",
                    "sNext"     : "Próximo",
                    "sLast"     : "Último"
                },
                language        : {
                    decimal : ",",
                }
            };
        }
    }
};